/* Harrow US: paid engraving linked to individual phone-case cart lines.
   Client-side consistency checks are not a substitute for server-side order validation. */
(function (global) {
  'use strict';
  var api = {};
  api.buildItems = function (o) {
    var parent = { id: Number(o.id), quantity: 1 };
    if (o.plan) parent.selling_plan = String(o.plan);
    if (!o.engraved) return [parent];
    if (!/^[A-Z]{1,3}$/.test(o.initials || '')) throw new Error('Enter one to three initials (A–Z).');
    if (['Classic', 'Script', 'Modern'].indexOf(o.style) < 0) throw new Error('Choose an engraving style.');
    if (!Number(o.feeId)) throw new Error('Engraving is temporarily unavailable.');
    var group = global.crypto && global.crypto.randomUUID ? global.crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2);
    parent.properties = { 'Engraved initials': o.initials, 'Engraving style': o.style,
      '_harrow_group': group, '_harrow_role': 'case', '_harrow_fee_variant': String(o.feeId) };
    return [parent, { id: Number(o.feeId), quantity: 1, properties: {
      '_harrow_initials': o.initials, '_harrow_style': o.style, 'For': o.title,
      '_harrow_group': group, '_harrow_role': 'fee' } }];
  };
  api.validate = function (cart) {
    var groups = {};
    cart.items.forEach(function (line) {
      var p = line.properties || {};
      if (!p._harrow_group) return;
      (groups[p._harrow_group] || (groups[p._harrow_group] = [])).push(line);
    });
    Object.keys(groups).forEach(function (key) {
      var lines = groups[key];
      var parents = lines.filter(function (l) { return l.properties._harrow_role === 'case'; });
      var fees = lines.filter(function (l) { return l.properties._harrow_role === 'fee'; });
      if (parents.length !== 1 || fees.length !== 1) throw new Error('An engraving charge is missing or unlinked. Remove the affected item and add it again before checkout.');
      var p = parents[0], f = fees[0];
      if (p.quantity !== f.quantity || String(f.variant_id) !== String(p.properties._harrow_fee_variant) ||
          f.original_price !== 499 ||
p.properties['Engraved initials'] !== (f.properties._harrow_initials || f.properties.Initials) ||
p.properties['Engraving style'] !== (f.properties._harrow_style || f.properties['Engraving style'])) {
        throw new Error('The engraving charge does not match its case. Remove the affected item and add it again.');
      }
    });
    return cart;
  };
  function request(url, body) {
    return fetch(url, body ? { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(body) } : {cache:'no-store'})
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || 'Basket update failed. Please try again.'); return data; }); });
  }
  function getCart() { return request(global.routes.cart_url + '.js'); }
  var queue = Promise.resolve();
  function enqueue(fn) { var result = queue.then(fn); queue = result.catch(function () {}); return result; }
  api.checkCart = function () { return queue.then(getCart).then(api.validate); };
  api.change = function (key, quantity) {
    return enqueue(function () {
      if (!Number.isInteger(quantity) || quantity < 0) throw new Error('Enter a whole-number quantity.');
      return getCart().then(function (before) {
        var target = before.items.find(function (l) { return l.key === key; });
        if (!target) throw new Error('Your basket changed. Refresh and try again.');
        var p = target.properties || {};
        if (p._harrow_role === 'fee') {
          if (quantity !== 0) throw new Error('Change the case quantity to update its engraving charge.');
          var linked = before.items.find(function (l) {return l.properties && l.properties._harrow_group === p._harrow_group && l.properties._harrow_role === 'case';});
          if (!linked) return request(global.routes.cart_change_url + '.js', {id:key, quantity:0});
          target = linked; key = linked.key; p = linked.properties;
        }
        // change.js checks the actual case inventory; do not use update.js to bypass inventory checks.
        return request(global.routes.cart_change_url + '.js', {id:key, quantity:quantity}).then(function (after) {
          if (!p._harrow_group) return after;
          var parent = after.items.find(function (l) { return l.properties && l.properties._harrow_group === p._harrow_group && l.properties._harrow_role === 'case'; });
          var fee = after.items.find(function (l) { return l.properties && l.properties._harrow_group === p._harrow_group && l.properties._harrow_role === 'fee'; });
          if (!fee) { if (!parent) return after; throw new Error('Engraving charge missing. Remove this case and add it again.'); }
          return request(global.routes.cart_change_url + '.js', {id:fee.key, quantity:parent ? parent.quantity : 0});
        });
      });
    });
  };
  global.HarrowEngraving = api;
  if (!global.document) return;
  function fail(error) { global.alert(error.message || error.description || 'Could not update your basket. Please refresh and try again.'); }
  document.addEventListener('DOMContentLoaded', function () {
    if (global.HarrowCart) {
      global.HarrowCart.change = function (key, qty) { return api.change(key, qty).catch(function (e) { fail(e); return getCart(); }); };
    }
  });
  var pageBusy = false;
  function savePage(form, checkout) {
    if (pageBusy) return;
    var values = Array.prototype.map.call(form.querySelectorAll('[data-us-cart-quantity]'), function (input) {
      return {key:input.getAttribute('data-us-cart-quantity'), qty:Number(input.value)};
    });
    if (values.some(function (v) { return !Number.isInteger(v.qty) || v.qty < 0; })) { fail(new Error('Enter whole-number quantities of zero or more.')); return; }
    pageBusy = true;
    // Read live keys after each change; Shopify can change line keys on discount recalculation.
    getCart().then(function (initial) {
      var changes = values.map(function (v) {
        var line = initial.items.find(function (l) { return l.key === v.key; });
        return {line:line, qty:v.qty};
      }).filter(function (v) {return v.line && v.line.quantity !== v.qty;});
      return changes.reduce(function (chain, change) {
        return chain.then(getCart).then(function (current) {
          var old = change.line;
          var now = current.items.find(function (l) {
            return l.variant_id === old.variant_id && JSON.stringify(l.properties || {}) === JSON.stringify(old.properties || {}) &&
              JSON.stringify(l.selling_plan_allocation || null) === JSON.stringify(old.selling_plan_allocation || null);
          });
          if (!now) throw new Error('Your basket changed. Refresh and try again.');
          return api.change(now.key, change.qty);
        });
      }, Promise.resolve());
    }).then(function () { if (checkout) return api.checkCart(); })
      .then(function () { if (checkout) global.location.href = global.routes.cart_url + '/checkout'; else global.location.reload(); })
      .catch(fail).finally(function () {pageBusy = false;});
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-us-cart-quantity]')) { e.stopImmediatePropagation(); savePage(e.target.form, false); }
  }, true);
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-us-cart-remove]');
    if (!remove) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (pageBusy) return;
    pageBusy = true;
    api.change(remove.getAttribute('data-us-cart-remove'), 0).then(function () {global.location.reload();}).catch(fail).finally(function () {pageBusy=false;});
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.matches('[data-us-cart-form]')) {
      e.preventDefault(); e.stopImmediatePropagation();
      savePage(e.target, !!(e.submitter && e.submitter.name === 'checkout')); return;
    }
    if (e.submitter && e.submitter.name === 'checkout' && e.target.closest('#CartDrawer')) {
      e.preventDefault(); e.stopImmediatePropagation();
      api.checkCart().then(function () {global.location.href = global.routes.cart_url + '/checkout';}).catch(fail);
    }
  }, true);
})(typeof window !== 'undefined' ? window : globalThis);
